import React from "react";
import Draggable from "./Draggable";

function Draggables({ draggableStyles }) {
  const draggables = () => {
    if (!draggableStyles) return;

    return draggableStyles.map((s, i) => {
      return <Draggable key={"draggable" + i} gridAreaStyle={s}></Draggable>;
    });
  };

  return <>{draggables()}</>;
}

export default Draggables;
